import { ref, watch } from 'vue'

export default function useTimeRange () {
  const startModel = ref(null)
  const endModel = ref(null)
  const initialOptions = ref([])
  const startOptions = ref([])
  const endOptions = ref([])

  /**
   * Формирует массив стартовых опций
   * @returns {*}
   */
  const transformInitialOptions = () => {
    const copy = JSON.parse(JSON.stringify(initialOptions.value))

    return copy.map((item, index) => ({ ...item, index }))
  }

  const transformStartOptions = () => {
    startOptions.value = transformInitialOptions()
  }

  const transformEndOptions = () => {
    const options = transformInitialOptions()

    const startItem = options.find(item => {
      return item.value === startModel.value
    })
    startItem.active = true

    let firstDisabledSearched = false
    options.forEach(item => {
      if (item.index < startItem.index) {
        item.disabled = true
      }

      if (item.index > startItem.index) {
        if (item.disabled) {
          firstDisabledSearched = true
        }

        if (firstDisabledSearched) {
          item.disabled = true
        }
      }
    })

    endOptions.value = options
  }

  /**
   * Устанавливает активный элемент старта
   * @param val
   */
  const setActiveStartItem = val => {
    startOptions.value.forEach(item => {
      delete item.active
    })

    const currentItem = startOptions.value.find(item => item.value === val)
    currentItem.active = true
  }

  const setActiveEndItem = val => {
    endOptions.value.forEach(item => {
      delete item.active
    })

    const startItem = endOptions.value.find(item => item.value === startModel.value)
    const endItem = endOptions.value.find(item => item.value === endModel.value)

    endOptions.value.forEach(item => {
      if (item.index <= endItem.index && item.index >= startItem.index) {
        item.active = true
      }
    })
  }

  watch(initialOptions, val => {
    transformStartOptions()
  })

  watch(startModel, val => {
    setActiveStartItem(val)
    transformEndOptions()
  })

  watch(endModel, val => {
    setActiveEndItem(val)
  })

  return {
    initialOptions,
    startModel,
    startOptions,
    endModel,
    endOptions
  }
}
